<h4  class="text-white display-block xs-text-center "> {{ currentNumber }}</h4>